import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environment';

import {
  AccessRule,
  Application,
  ApplicationGroup,
  NewRole,
  Profile,
} from '../models/contactperson.model';

@Injectable()
export class AuthorizationService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/authorization/secure/`;

  getProfileId(ExternalId: string, System: string, ExternalEntityTypeEnum: string) {
    return this.http.get<Profile>(`${this.baseUrl}userprofile/id`, {
      params: {
        ExternalId,
        System,
        ProfileBasedOnEntityEnum: ExternalEntityTypeEnum,
      },
    });
  }

  getApplications() {
    return this.http.get<Application[]>(`${this.baseUrl}access/application`);
  }

  getApplicationGroups() {
    return this.http.get<ApplicationGroup[]>(`${this.baseUrl}access/application-group/Agrifirm`);
  }

  getRoles() {
    return this.http.get<NewRole[]>(`${this.baseUrl}access/role`);
  }

  getUseraccess(profileId: number) {
    return this.http.get<AccessRule[]>(`${this.baseUrl}access/useraccess`, {
      params: { ProfileId: profileId.toString() },
    });
  }

  deleteUseraccess(profileId: number, applicationKey: string) {
    return this.http.request('DELETE', `${this.baseUrl}access/useraccess`, {
      body: { profileId, applicationKey },
    });
  }

  setUseraccess(profileId: number, applicationKey: string, roleKey: string) {
    return this.http.post(`${this.baseUrl}access/useraccess`, {
      profileId,
      applicationKey,
      roleKey,
    });
  }
}
